<div class="modal fade" id="kt_modal_inspection_add_edit" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered mw-650px">
    <div class="modal-content">
      <div class="modal-header p-3 d-flex justify-content-between bg-secondary">
        <h2 class="fw-bold m-0">{{ isEditMode ? 'Update Inspection' : 'Add Inspection' }}</h2>
        <div class="btn btn-icon btn-sm btn-active-icon-primary" data-bs-dismiss="modal">
          <i class="ki-duotone ki-cross fs-1">
            <span class="path1"></span>
            <span class="path2"></span>
          </i>
        </div>
      </div>

      <form [formGroup]="inspectionForm" (ngSubmit)="onSubmit()" novalidate>
        <div class="modal-body p-5">
          <div class="row">
            <!-- Caption -->
            <div class="col-md-12 mb-5">
              <label class="form-label required">Caption</label>
              <input
                type="text"
                class="form-control form-control-solid"
                formControlName="caption"
                placeholder="Enter inspection caption"
                [class.is-invalid]="caption?.invalid && caption?.touched"
              />
              <div *ngIf="caption?.invalid && caption?.touched" class="invalid-feedback">
                <div *ngIf="caption?.errors?.['required']">Caption is required</div>
                <div *ngIf="caption?.errors?.['minlength']">Caption must be at least 2 characters</div>
              </div>
            </div>

            <!-- Description -->
            <div class="col-md-12 mb-5">
              <label class="form-label">Description</label>
              <textarea
                class="form-control form-control-solid"
                formControlName="description"
                placeholder="Enter inspection description"
                rows="3">
              </textarea>
            </div>

            <!-- Status -->
            <div class="col-md-6 mb-5">
              <label class="form-label required">Status</label>
              <div class="d-flex gap-3">
                <div class="form-check">
                  <input
                    class="form-check-input"
                    type="radio"
                    formControlName="status"
                    [value]="1"
                    id="status_active">
                  <label class="form-check-label" for="status_active">
                    Active
                  </label>
                </div>
                <div class="form-check">
                  <input
                    class="form-check-input"
                    type="radio"
                    formControlName="status"
                    [value]="0"
                    id="status_inactive">
                  <label class="form-check-label" for="status_inactive">
                    Inactive
                  </label>
                </div>
              </div>
              <div *ngIf="status?.invalid && status?.touched" class="invalid-feedback d-block">
                <div *ngIf="status?.errors?.['required']">Status is required</div>
              </div>
            </div>

            <!-- Display Order -->
            <div class="col-md-6 mb-5">
              <label class="form-label required">Display Order</label>
              <input
                type="number"
                class="form-control form-control-solid"
                formControlName="display_order"
                placeholder="Enter display order"
                min="0"
                [class.is-invalid]="display_order?.invalid && display_order?.touched"
              />
              <div *ngIf="display_order?.invalid && display_order?.touched" class="invalid-feedback">
                <div *ngIf="display_order?.errors?.['required']">Display order is required</div>
                <div *ngIf="display_order?.errors?.['min']">Display order must be 0 or greater</div>
              </div>
            </div>
          </div>
        </div>

        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-light me-3"
            data-bs-dismiss="modal"
            [disabled]="isLoading">
            Cancel
          </button>
          <button
            type="submit"
            class="btn btn-primary"
            [disabled]="isLoading">
            <span *ngIf="isLoading" class="spinner-border spinner-border-sm me-2"></span>
            {{ isEditMode ? 'Update' : 'Add' }}
          </button>
        </div>
      </form>
    </div>
  </div>
</div>
